/**
 Author - Muhamed Afsal
 Git - https://bitbucket.org/mohdafsal/
 **/

import React from "react";
import SafeLink from "components/commons/SafeLink";
import PropTypes from "prop-types";

import styled, {css} from "styled-components";

import {WealthyEnv} from "helpers";

// TODO: Fix Wealthy Purple Logo in Partner page

const propTypes = {
  activeLink: PropTypes.object.isRequired,
  color: PropTypes.string.isRequired,
  isNewPartnerPage: PropTypes.bool.isRequired,
  setToggleModal: PropTypes.func.isRequired,
  showSidePanel: PropTypes.bool.isRequired,
  toggleShowSidePanel: PropTypes.func.isRequired
};

const defaultProps = {
  color: "#193176",
  isNewPartnerPage: false
};

const MobileNavbar = ({
  color,
  showSidePanel,
  toggleShowSidePanel,
  activeLink,
  isNewPartnerPage,
  setToggleModal
}) => {
  const toggleDropdown = (event) => {
    const adjacentElement = event.currentTarget.nextElementSibling;
    adjacentElement.classList.toggle("show");

    const expandIcon = event.currentTarget.querySelector(".toggle-icon__btn");
    expandIcon.classList.toggle("rotate-down");
  };

  let content;
  const isActiveLinkPresent = activeLink.url;
  const isPwpPage = isActiveLinkPresent && activeLink.pathname.includes("private-wealth-partner");
  if (isActiveLinkPresent) {
    content = (
      <>
        {
          isNewPartnerPage && !isPwpPage && (
            <>
              {
                !activeLink.isNewInvestorsPage && (
                  <li>
                    <SafeLink href="#register">
                  Join as a partner
                    </SafeLink>
                  </li>
                )
              }
              <li>
                <SafeLink
                  onClick={isNewPartnerPage ? () => {
                    setToggleModal(true);
                    toggleShowSidePanel(false);
                  } : undefined}
                >
                  Log in
                </SafeLink>
              </li>
            </>
          )
        }
        {
          activeLink?.subLinks?.map(subLink => {
            if (subLink.dropdownLinks) {
              return (
                <>
                  <li onClick={toggleDropdown}>
                    <SafeLink href={subLink.url}>
                      {subLink.text}
                    </SafeLink>
                    <div className="toggle-icon__btn">
                      <button className="toggle-icon" />
                    </div>
                  </li>
                  <ul className="dropdown-links-container">
                    {
                      subLink.dropdownLinks.map(dropdownLink => (
                        <li className="dropdown-links">
                          <SafeLink href={dropdownLink.url}>{dropdownLink.text}</SafeLink>
                        </li>
                      ))
                    }
                  </ul>
                </>
              );
            } else {
              return (
                <li>
                  <SafeLink href={subLink.url}>
                    {subLink.text}
                  </SafeLink>
                </li>
              );
            }
          })
        }
        {
          activeLink.adjacentLink && (
            <li className="adjacent-link">
              <SafeLink href={activeLink.adjacentLink.url}>
                {activeLink.adjacentLink.text}
              </SafeLink>
            </li>
          )
        }

      </>
    );
  } else {
    content = (
      <>
        <li>
          <SafeLink href={`${WealthyEnv.URL}`}>
            FOR CLIENTS
          </SafeLink>
        </li>
        <li>
          <SafeLink href="/partner">
            FOR PARTNERS
          </SafeLink>
        </li>
        <li>
          <SafeLink href="/careers">
            CAREERS
          </SafeLink>
        </li>
      </>
    );
  }

  return (
    <Navbar $hamburgerIconColor={color}>
      <HamburgerButtonContainer
        $open={showSidePanel}
        onClick={() => toggleShowSidePanel(!showSidePanel)}
      >
        {
          isNewPartnerPage && (
            <WealthyLogoContainer>
              <img alt="wealthy-logo" className="wealthy-purple-logo" src="https://i.wlycdn.com/wealthy-home-page/wealthy-purple-logo.webp" />
            </WealthyLogoContainer>
          )
        }
        <HamburgerButton $open={showSidePanel} />
      </HamburgerButtonContainer>
      {
        showSidePanel &&
        (
          <SidePanel>
            <Menu $open={showSidePanel}>
              <MobileLinks>
                {content}
                {
                  isActiveLinkPresent &&
                  activeLink.loginUrl &&
                  (
                    <li>
                      <SafeLink href={activeLink.loginUrl}>
                        LOGIN
                      </SafeLink>
                    </li>
                  )
                }
                {
                  isActiveLinkPresent &&
                  activeLink.downloadUrl &&
                  (
                    <li>
                      <SafeLink href={activeLink.downloadUrl}>
                        DOWNLOAD APP
                      </SafeLink>
                    </li>
                  )
                }
                {
                  isNewPartnerPage && !activeLink.isNewInvestorsPage && (
                    <DownloadPartnerApp href={`${WealthyEnv.WEALTHY_PARTNERS_APP_LINK_WITHOUT_UTM}&referrer=utm_source%3Dorganic%26utm_medium%3Dwebsite_mobile_header%26utm_term%3Dpartner_app_install`}>
                      <img
                        alt="download-partner-app-banner"
                        className="download-partner-app"
                        src={`${WealthyEnv.HOMEPAGE_CDN_URL}/partners-mobiler-header-banner.svg`}
                      />
                    </DownloadPartnerApp>
                  )
                }
              </MobileLinks>
            </Menu>
            <Overlay
              $open={showSidePanel}
              onClick={() => toggleShowSidePanel(false)}
            />
          </SidePanel>
        )
      }
    </Navbar>
  );
};

const DownloadPartnerApp = styled(SafeLink)`
  .download-partner-app {
    width: 100%;
    margin-top: 4.4rem;
  }
`;

const WealthyLogoContainer = styled.div`
  display: none;
  /* @media (max-width: 768px) {
    width: 55%;
    display: block;
    .wealthy-purple-logo {
      width: 100%;
    }
  } */
`;

const Navbar = styled.div`
  --hamburger-icon-color: ${props => props.$hamburgerIconColor};
  display: none;

  @media (max-width: 768px) {
    display: flex;
    margin-left: auto;
    align-items: center;
    margin-right: 2.5%;
  }
`;

const HamburgerButtonContainer = styled.div`
  position: relative;
  z-index: 501;
  cursor: pointer;
  padding: 1rem;
  right: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 98%;
`;

const HamburgerButton = styled.div`
  background: var(--hamburger-icon-color);
  cursor: pointer;
  border-radius: 1px;
  height: 3px;
  width: 20px;
  border: 0;
  margin: 0;
  padding: 0;
  display: block;
  left: 0;

  &::after,
  &::before {
    cursor: pointer;
    border-radius: 1px;
    height: 3px;
    width: 20px;
    background: var(--hamburger-icon-color);
    position: absolute;
    display: block;
    content: '';
  }

  &::before {
    transform: translateY(-6px);
  }

  &::after {
    transform: translateY(6px);
  }

  ${props => props.$open && css`
    width: 0;

    &::before {
      transform: translate(-6px, -4px) rotate(45deg);
    }

    &::after {
      transform: translate(-6px, -4px) rotate(-45deg);
    }

    &::before,
    &::after {
      width: 18px;
      background: #193176;
    }
  `}
`;

const SidePanel = styled.div`
`;

const Menu = styled.div`
  display: flex;
  position: fixed;
  height: 100vh;
  padding: 60px 0;
  z-index: 500;
  right: 0;
  top: 0;
  opacity: 1;
  overflow: hidden;
  transform: translateX(100%);
  flex-direction: column;
  width: 70%;
  box-sizing: border-box;
  max-width: 250px;
  box-sizing: initial;
  text-align: left;
  background: #fff;
  box-sizing: border-box;
  transition: transform 300ms cubic-bezier(0.45,0.05,0.55,0.95);

  ${props => props.$open && css`
    padding: 60px 20px 0 16px;
    transform: translateX(0);
    box-shadow: 0 0 30px rgb(0 0 0 / 20%);
  `}
`;

const Overlay = styled.div`
  background: rgba(0, 0, 0, 0.5);
  transform: translateX(100%);
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  width: 0;
  height: 100vh;
  z-index: 498;
  width: 100vw;
  transform: translateX(0);
`;

const MobileLinks = styled.ul`
  li {
    display: flex;
    align-items: center;
    padding: 1rem;
    cursor: pointer;
    justify-content: space-between;

    a {
      color: #193076;
      font-weight: 400;
      font-family: Avenir-Heavy;
      font-size: 14px;
    }

    .adjacent-link {
      font-family: Avenir-Heavy;
    }
  }

  .dropdown-links-container {
    display: none;
  }

  .dropdown-links-container.show {
    display: block;
  }

  .dropdown-links {
    a {
      font-family: Avenir-Book;
    }
  }

  .download-links {
    a {
      font-family: Avenir-Heavy;
    }
  }

  .toggle-icon__btn {
    width: 24px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 3px;
    cursor: pointer;
    margin-right: 14px;
  }

  .toggle-icon {
    width: 0;
    border: none;
    background: #19509b;
    display: block;
    transform: rotate(90deg);
    transition: transform 200ms ease;
    transform-origin: 1px 4px;
  }

  .toggle-icon:after, .toggle-icon:before {
    content: "";
    height: 2px;
    width: 8px;
    background: #19509b;
    display: block;
    transition: transform 200ms ease;
  }

  .toggle-icon::before {
    transform: rotate(45deg);
  }

  .toggle-icon::after {
    transform: translateY(2px) rotate(-45deg);
  }

  .toggle-icon__btn.rotate-down .toggle-icon {
    transform: rotate(-90deg);
  }
`;

MobileNavbar.propTypes = propTypes;
MobileNavbar.defaultProps = defaultProps;

export default MobileNavbar;
